import Upload from './upload.vue'

export default Upload



// WEBPACK FOOTER //
// ./src/components/upload/index.js